import { ApplicationSectionKeys } from 'src/app/constants/app.constants';
import { GasDeviceObject } from 'src/app/jurisdiction/facilities-form/facilities-form.domain';
import { AllDropdownKeys } from 'src/app/jurisdiction/jurisdiction.constants';
import { CustomFieldType } from 'src/app/+shared/custom-fields/models/enums/customFieldType';
import { GasDeviceDataResponse } from 'src/app/jurisdiction/jurisdiction.domain';
import { CustomFieldValidatorType } from '../models/enums/customFieldValidatorType';

const ceNumber = {
  name: 'ceNumber',
  label: 'facilities-data.form-fields.ce-number',
  section: ApplicationSectionKeys.technicalData.gasDevice,
  type: CustomFieldType.Text,
  required: true,
};

const selectedGasCategory = {
  name: 'selectedGasCategory',
  label: 'facilities-data.form-fields.set-gas-type',
  section: ApplicationSectionKeys.technicalData.gasDevice,
  type: CustomFieldType.Dropdown,
  dropdownTypeKey: AllDropdownKeys.SelectedGasCategory,
  required: true,
};

const applianceType = {
  name: 'applianceType',
  label: 'facilities-data.form-fields.gas-appliance-type',
  section: ApplicationSectionKeys.technicalData.gasDevice,
  type: CustomFieldType.DynamicDropdown,
  required: true,
  resource: 'gasdevicetype',
  mappingFunction: (response: GasDeviceDataResponse) =>
    response.gasdevicetype.map(x => ({ label: x.device_type, value: x.id, order: +x.id })),
};

const manufacturer = {
  name: 'manufacturer',
  label: 'facilities-data.form-fields.manufacturer',
  section: ApplicationSectionKeys.technicalData.gasDevice,
  type: CustomFieldType.Dropdown,
  dropdownTypeKey: AllDropdownKeys.DeviceManufacturer,
  required: true,
};

const otherManufacturer = {
  name: 'otherManufacturer',
  label: 'facilities-data.form-fields.other-manufacturer',
  section: ApplicationSectionKeys.technicalData.gasDevice,
  type: CustomFieldType.Text,
  required: true,
  displayFunction: (value: GasDeviceObject) => value.manufacturer === 'other',
};

const deviceType = {
  name: 'type',
  label: 'facilities-data.form-fields.type',
  section: ApplicationSectionKeys.technicalData.gasDevice,
  type: CustomFieldType.Text,
  required: true,
};

const manufactureYear = {
  name: 'manufactureYear',
  label: 'facilities-data.form-fields.year-of-manufacture',
  section: ApplicationSectionKeys.technicalData.gasDevice,
  type: CustomFieldType.Number,
  required: true,
  validators: [{ type: CustomFieldValidatorType.MaxLength, args: { maxLength: 4 } }],
};

const applianceCategory = {
  name: 'applianceCategory',
  label: 'facilities-data.form-fields.gas-appliance-category',
  section: ApplicationSectionKeys.technicalData.gasDevice,
  type: CustomFieldType.Dropdown,
  dropdownTypeKey: AllDropdownKeys.DeviceCategory,
  required: true,
};

const deviceName = {
  name: 'deviceName',
  label: 'facilities-data.form-fields.device-name',
  section: ApplicationSectionKeys.technicalData.gasDevice,
  type: CustomFieldType.Text,
  required: true,
};

const power = {
  name: 'power',
  label: 'facilities-data.form-fields.device-power',
  section: ApplicationSectionKeys.technicalData.gasDevice,
  type: CustomFieldType.Number,
  required: true,
};

const deviceRemovedCheckbox = {
  name: 'deviceRemovedCheckbox',
  section: ApplicationSectionKeys.technicalData.gasDevice,
  type: CustomFieldType.Checkbox,
  emptyLabel: true,
  label: 'facilities-data.form-fields.device-removed-checkbox',
};

export default {
  ceNumber,
  selectedGasCategory,
  applianceType,
  manufacturer,
  otherManufacturer,
  deviceType,
  manufactureYear,
  applianceCategory,
  deviceName,
  power,
  deviceRemovedCheckbox,
};
